import { ApiResponseType } from "../../../../../../core/data/rtk/apiResponseType";
import { baseApi } from "../../../../../../core/data/rtk/baseQuery";
import { PaymentDetailsResponse } from "../../../billing/types/PaymentDetailsResponse";

export const razorpayApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    makeRazorpayPayment: builder.mutation<any, { center_id: number; student_id: number; amount: number; invoice_id: number }>({
      query: (body) => ({
        url: '/student-payments/initiate',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Students']
    }),
    verifyRazorpayPayment: builder.mutation<any, { paymentId: string; payload: any }>({
      query: ({ paymentId, payload }) => ({
        url: `/student-payments/verify/${paymentId}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Invoices', 'Students']
    }),
    getStudentPaymentById: builder.query<
      ApiResponseType<{ payments: PaymentDetailsResponse }>,
      { id: string }
    >({
      query: ({ id }) => `student-payments/get-by-studentid/${id}`,
      providesTags: ["Invoices", "Students" ],
    }),
  }),
});

export const { useMakeRazorpayPaymentMutation, useVerifyRazorpayPaymentMutation, useGetStudentPaymentByIdQuery } = razorpayApi;